module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default; 
    ; __append("\r\n<div id=\"")
    ; __append(escapeFn( id ))
    ; __append("\" class=\"pf-control button has-menu\" tabindex=\"")
    ; __append(escapeFn( tabIndex ))
    ; __append("\" draggable=\"true\"\r\n     style=\"left:")
    ; __append(escapeFn( left ))
    ; __append("px; top:")
    ; __append(escapeFn( top ))
    ; __append("px;\r\n             width: ")
    ; __append(escapeFn( u.extractNum(width)))
    ; __append("px; height: ")
    ; __append(escapeFn( u.extractNum(height) + (u.extractNum(buttonFontSize) * .25) ))
    ; __append("px;\r\n             z-index:")
    ; __append(escapeFn( zOrder ))
    ; __append(";\">\r\n\r\n    <div class=\"size-handle-top\"    style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-left\"   style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n\r\n    <div class=\"pf-control-core pf-selectable\" style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) + 2 + (u.extractNum(buttonFontSize) * .25) ))
    ; __append("px; width: ")
    ; __append(escapeFn( u.extractNum(width)+2 ))
    ; __append("px;\r\n\r\n                -webkit-border-radius: 0px;\r\n                -moz-border-radius: 0px;\r\n                border-radius: 0px;\r\n                border: 1px dotted #ffffff;\">\r\n        ")
    ;  if( buttonPositionAbove === 'true') { 
    ; __append("\r\n        <div style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px; height: 23px;\">\r\n            <img src=\"")
    ; __append( require('editor/buttons/gray_up.png') )
    ; __append("\" class=\"factory-widget-icon\" style=\"float: left; height: 15px; width: 22px;\"/>\r\n            <div style=\"width: 200px; height: 23px; border: solid 1px; float: left; margin-left: 5px; border-bottom: none\">\r\n                <button\r\n                        style=\" margin-left: 5px;\r\n                                overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\r\n                                border: 1px solid ")
    ; __append(escapeFn(borderColor))
    ; __append(";\r\n                                border-radius: 2px;\r\n                                font-family: '")
    ; __append(escapeFn(buttonFontFamily))
    ; __append("'; font-size: ")
    ; __append(escapeFn(buttonFontSize))
    ; __append("px;\r\n                                font-style: ")
    ; __append(escapeFn(buttonTextStyle))
    ; __append("; font-weight: ")
    ; __append(escapeFn(buttonTextWeight))
    ; __append(";\r\n                                color: ")
    ; __append(escapeFn(buttonTextColor))
    ; __append(";\r\n                                background: ")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append(";\r\n                                background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append("), to(")
    ; __append(escapeFn(buttonBackgroundGradientColor))
    ; __append("));\r\n                                background: -webkit-linear-gradient(0% 0%, 0% 100%, from(")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append("), to(")
    ; __append(escapeFn(buttonBackgroundGradientColor))
    ; __append("));\r\n                                background: -moz-linear-gradient(center top,  ")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append(", ")
    ; __append(escapeFn(buttonBackgroundGradientColor))
    ; __append(");\r\n                                background: linear-gradient(to bottom, ")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append(", ")
    ; __append(escapeFn(buttonBackgroundGradientColor))
    ; __append(");\"\r\n                >")
    ; __append(escapeFn( buttonLabelAcquire ))
    ; __append("</button>\r\n            </div>\r\n        </div>\r\n        <div style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px; height: ")
    ; __append(escapeFn( u.extractNum(height) -23 ))
    ; __append("px; border: solid 1px; background-color: ")
    ; __append(escapeFn(imageBackgroundColor ))
    ; __append("\">&nbsp;</div>\r\n        ")
    ;  }
        else{
        
    ; __append("\r\n        <div style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px; height: ")
    ; __append(escapeFn( u.extractNum(height) -13 -u.extractNum(buttonFontSize) ))
    ; __append("px; border: solid 1px; background-color: ")
    ; __append(escapeFn(imageBackgroundColor ))
    ; __append("\">&nbsp;</div>\r\n        <div style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px; height: 23px;\">\r\n            <img src=\"")
    ; __append( require('editor/buttons/gray_down.png') )
    ; __append("\" class=\"factory-widget-icon\" style=\"float: left; height: 15px; width: 22px;\"/>\r\n            <div style=\"width: 205px; height: ")
    ; __append(escapeFn( 13 + (u.extractNum(buttonFontSize) * 1.25) ))
    ; __append("px; border: solid 1px; float: left; margin-left: 5px; border-top: none\">\r\n                <button\r\n                        style=\" margin-left: 5px;\r\n                                overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\r\n                                border: 1px solid ")
    ; __append(escapeFn(borderColor))
    ; __append(";\r\n                                border-radius: 2px;\r\n                                font-family: '")
    ; __append(escapeFn(buttonFontFamily))
    ; __append("'; font-size: ")
    ; __append(escapeFn(buttonFontSize))
    ; __append("px;\r\n                                font-style: ")
    ; __append(escapeFn(buttonTextStyle))
    ; __append("; font-weight: ")
    ; __append(escapeFn(buttonTextWeight))
    ; __append(";\r\n                                color: ")
    ; __append(escapeFn(buttonTextColor))
    ; __append(";\r\n                                background: ")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append(";\r\n                                background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append("), to(")
    ; __append(escapeFn(buttonBackgroundGradientColor))
    ; __append("));\r\n                                background: -webkit-linear-gradient(0% 0%, 0% 100%, from(")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append("), to(")
    ; __append(escapeFn(buttonBackgroundGradientColor))
    ; __append("));\r\n                                background: -moz-linear-gradient(center top,  ")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append(", ")
    ; __append(escapeFn(buttonBackgroundGradientColor))
    ; __append(");\r\n                                background: linear-gradient(to bottom, ")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append(", ")
    ; __append(escapeFn(buttonBackgroundGradientColor))
    ; __append(");\"\r\n                >")
    ; __append(escapeFn( buttonLabelAcquire ))
    ; __append("</button>\r\n            </div>\r\n        </div>\r\n        ")
    ; }
    ; __append("\r\n    </div>\r\n\r\n    <div class=\"size-handle-right\"  style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-bottom\" style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px;\"></div>\r\n</div>\r\n\r\n\r\n")
  }
  return __output;

}